import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';

import Loading from '../../../generals-components/loading'

async function getUserSessions(date_i, date_f, car, page) {
    const response = await fetch('/api/get-user-racing-sessions', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            date_i: date_i,
            date_f: date_f,
            carName: car,
            page: page
        })
    });

    if (response.ok) {
        const user_sessions = await response.json();
        console.log(user_sessions)
        return user_sessions;
    } else {
        return undefined;
    }
}

function SessionsPageMain() {
    const [isReady, setIsReady] = useState(false)

    const [inputCarVisibility, setInputCarVisibility] = useState(false)
    const [inputDateVisibility, setInputDateVisibility] = useState(false)

    const [filterDateI, setFilterDateI] = useState(Math.floor(new Date().setHours(0, 0, 0, 0) / 1000))
    const [filterDateF, setFilterDateF] = useState(Math.floor(Date.now() / 1000))

    const [filterDateText, setFilterDateText] = useState("today") 

    const [filterCar, setFilterCar] = useState("")
    const [filterPage, setFilterPage] = useState(1)

    const [totalPages, setTotalPages] = useState(0)

    const [userSessions, setUserSessions] = useState(undefined)

    const [userCars, setUserCars] = useState([])

    const toggleCarVisibility = () => {
        if (inputCarVisibility) {setInputCarVisibility(false)} else {setInputCarVisibility(true)}
    }

    const toggleDateVisibility = () => {
        if (inputDateVisibility) {setInputDateVisibility(false)} else {setInputDateVisibility(true)}
    }

    const handlePageChange = (page) => {
        if (page <= 0 || page > totalPages) {return;}

        setFilterPage(page)
    }

    const handleDateFilterChange = (f, i, text) => {
        setFilterDateI(i)
        setFilterDateF(f)
        setFilterDateText(text)
    }

    const handleCarFilterChange = (car) => {
        setFilterCar(car)
    }

    useEffect(() => {
        const fetchUserSessions = async () => {
            const response = await getUserSessions(filterDateI, filterDateF, filterCar, filterPage)

            if (response !== undefined) {
                setUserSessions(response)

                setTotalPages(Math.ceil(parseInt(response.totals["filter_lenght"]) / 5))

                setUserCars(response["user_cars"])
            }

            setIsReady(true)
        }

        setIsReady(false)
        fetchUserSessions()
    }, [filterDateI, filterDateF, filterCar, filterPage])

    return (
        <main className="flex w-full flex-1 justify-center py-10 px-5 md:px-5 lg:px-5 carbon-pattern">
                <div className="layout-content-container flex flex-col max-w-[1200px] w-full flex-1">
                    <div className="flex flex-wrap justify-between items-end gap-6 mb-8">
                        <div className="flex flex-col gap-2">
                            <h1 className="text-slate-900 dark:text-white text-4xl font-black leading-tight tracking-tight font-display uppercase">Session History</h1>
                            <p className="text-slate-500 dark:text-[#92adc9] text-base font-normal">Review your performance and manage past racing data exports</p>
                        </div>
                    </div>

                    <div className="flex flex-col gap-4 mb-6">
                        <div className="gap-4 flex flex-wrap items-center">

                            <div className="relative group">
                                <button onClick={() => toggleCarVisibility()} className="flex items-center gap-2 px-5 h-14 bg-surface-dark border border-border-dark text-white rounded-xl font-medium hover:border-primary/50 transition-colors">
                                    <span className="material-symbols-outlined text-[20px]">directions_car</span>
                                    <span>All Cars</span>
                                    <span className="material-symbols-outlined text-[20px]">expand_more</span>
                                </button>

                                <div className={`${inputCarVisibility ? "visible" : "hidden"} absolute top-full left-0 mt-2 w-72 bg-surface-dark border border-border-dark rounded-xl shadow-2xl z-[60] overflow-hidden py-2`}>
                                    <div className="px-4 py-2 text-xs font-bold text-[#92adc9] uppercase tracking-wider border-b border-border-dark/50 mb-1">Select Vehicle</div>
                                    
                                    <div className="flex flex-col max-h-[200px] overflow-x-scroll">
                                        <button onClick={() => handleCarFilterChange("")} className={`${filterCar === "" ? "bg-primary text-white font-medium hover:bg-primary" : "text-slate-300 hover:bg-primary/10 hover:text-white"} flex items-center px-4 py-3 text-sm transition-colors`}>
                                            <span className="material-symbols-outlined mr-3 text-[18px]">directions_car</span>
                                            All Cars
                                            {filterCar === "" &&
                                                <span className="material-symbols-outlined ml-auto text-[18px]">check</span>
                                            }
                                        </button>

                                        {userCars.map((item) => (
                                            <button onClick={() => handleCarFilterChange(item)} key={item} className={`${item === filterCar ? "bg-primary text-white hover:bg-primary font-medium" : "text-slate-300 hover:bg-primary/10 hover:text-white"} flex items-center px-4 py-3 text-sm transition-colors`}>
                                                <span className="material-symbols-outlined mr-3 text-[18px]">directions_car</span>
                                                {item}

                                                {item === filterCar &&
                                                    <span className="material-symbols-outlined ml-auto text-[18px]">check</span>
                                                }
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="relative group">
                                <button onClick={() => toggleDateVisibility()} className="flex items-center gap-2 px-5 h-14 bg-surface-dark border border-border-dark text-white rounded-xl font-medium hover:border-primary/50 transition-colors">
                                    <span className="material-symbols-outlined text-[20px]">calendar_today</span>
                                    <span>Date Range</span>
                                    <span className="material-symbols-outlined text-[20px]">expand_more</span>
                                </button>

                                <div className={`${inputDateVisibility ? "visible" : "hidden"} absolute z-[60] mt-2 w-80 bg-surface-dark border border-border-dark rounded-xl shadow-2xl p-2 pb-4 flex flex-col gap-4 animate-in fade-in slide-in-from-top-2 duration-200`}>
                                    <div className="flex flex-col gap-1">
                                        <button onClick={() => handleDateFilterChange(Math.floor(Date.now() / 1000), Math.floor(new Date().setHours(0, 0, 0, 0) / 1000), "today")} className={`${filterDateText === "today" ? "bg-primary/20 text-primary font-bold" : "hover:bg-primary/10 text-slate-300 hover:text-white transition-colors"} flex items-center justify-between px-3 py-2 rounded-lg text-sm`}>
                                            <span>Today</span>
                                            {filterDateText === "today" && 
                                                <span className="material-symbols-outlined text-sm">check</span>
                                            }
                                        </button>
                                        <button onClick={() => handleDateFilterChange(Math.floor(Date.now() / 1000), Math.floor(Date.now() / 1000) - (7 * 24 * 60 * 60), "week")} className={`${filterDateText === "week" ? "bg-primary/20 text-primary font-bold" : "hover:bg-primary/10 text-slate-300 hover:text-white transition-colors"} flex items-center justify-between px-3 py-2 rounded-lg text-sm`}>
                                            <span>Last 7 Days</span>
                                            {filterDateText === "week" && 
                                                <span className="material-symbols-outlined text-sm">check</span>
                                            }
                                        </button>
                                        <button onClick={() => handleDateFilterChange(Math.floor(Date.now() / 1000), Math.floor(Date.now() / 1000) - (30 * 24 * 60 * 60), "month")} className={`${filterDateText === "month" ? "bg-primary/20 text-primary font-bold" : "hover:bg-primary/10 text-slate-300 hover:text-white transition-colors"} flex items-center justify-between px-3 py-2 rounded-lg text-sm`}>
                                            <span>Last 30 Days</span>
                                            {filterDateText === "month" && 
                                                <span className="material-symbols-outlined text-sm">check</span>
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="rounded-t-xl overflow-hidden border border-border-dark bg-surface-dark shadow-2xl w-full">
                        <div className="overflow-x-auto relative w-full h-full flex">
                            {isReady ?
                                (userSessions !== undefined && userSessions?.history !== undefined && userSessions?.history.length > 0) ?
                                    <table className="min-w-[1200px] md:w-full text-left border-collapse">
                                        <thead>
                                            <tr className="bg-border-dark/50 border-b border-border-dark">
                                                <th className="px-4 py-4 text-white text-sm font-bold uppercase tracking-wider w-[18%]">Track Name</th>
                                                <th className="px-4 py-4 text-white text-sm font-bold uppercase tracking-wider w-[14%]">Date &amp; Time</th>
                                                <th className="px-4 py-4 text-white text-sm font-bold uppercase tracking-wider w-[18%]">Vehicle</th>
                                                <th className="px-4 py-4 text-white text-sm font-bold uppercase tracking-wider w-[10%]">Session</th>
                                                <th className="px-4 py-4 text-white text-sm font-bold uppercase tracking-wider w-[10%]">Best Lap</th>
                                                <th className="px-4 py-4 text-white text-sm font-bold uppercase tracking-wider w-[8%]">Laps</th>
                                                <th className="px-4 py-4 text-white text-sm font-bold uppercase tracking-wider w-[10%]">Distance</th>
                                                <th className="px-4 py-4 text-white text-sm font-bold uppercase tracking-wider text-center w-[12%]">Telemetry</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-border-dark">
                                            {userSessions?.history?.map((item, index) => (
                                                <tr key={index} className="hover:bg-primary/5 transition-colors group">
                                                
                                                    <td className="px-4 py-5">
                                                        <div className="flex items-center gap-3">
                                                            <div className="size-8 rounded bg-background-dark flex items-center justify-center text-primary font-bold">{item.track[0]}{item.track[1]}</div><span className="text-white font-bold text-base">{item.track}</span>
                                                        </div>
                                                    </td>
                                                    <td className="px-4 py-5 text-[#92adc9] text-sm">{item.date}</td>
                                                    <td className="px-4 py-5">
                                                        <div className="flex flex-col"><span className="text-white font-medium capitalize">{item.car}</span></div>
                                                    </td>
                                                    <td className="px-4 py-5"><span className="text-[#92adc9] text-sm">{item.type}</span></td>
                                                    <td className="px-4 py-5 font-mono text-primary text-sm">{item["best_lap"]}</td>
                                                    <td className="px-4 py-5"><span className="px-3 py-1 bg-border-dark rounded text-white text-xs font-bold">{item.laps}</span></td>
                                                    <td className="px-4 py-5 text-[#92adc9] text-sm">{Math.round(item.distance / 1000).toFixed(1)} km</td>
                                                    <td className="px-4 py-5 text-center"><button className="inline-flex items-center justify-center size-10 bg-primary/10 hover:bg-primary text-primary hover:text-white rounded-lg transition-all" title="Download MoTeC"><span className="material-symbols-outlined text-[20px]">download</span></button></td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                            
                                    :

                                    <div className="flex flex-1 flex-col items-center justify-center py-20 px-6 rounded-xl dark:border-slate-800 dark:bg-slate-900/20">
                                        <div className="relative mb-8">
                                            <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full"></div>
                                            <div className="relative flex items-center justify-center size-24 lg:size-32 bg-slate-200 dark:bg-slate-800 rounded-full text-slate-400 dark:text-slate-600 border-4 border-slate-100 dark:border-slate-900 overflow-hidden">
                                                <span className="material-symbols-outlined text-5xl lg:text-6xl">query_stats</span>
                                            </div>
                                        </div>
                                        <div className="max-w-md text-center">
                                            <h2 className="text-2xl font-bold mb-3 tracking-tight">No racing sessions found yet</h2>
                                            <p className="text-slate-500 dark:text-slate-400 leading-relaxed mb-8">
                                                Your racing sessions will appear here once the local telemetry client is running and your data has been successfully synced to the cloud. Start your engines to begin collecting data.
                                            </p>
                                        </div>
                                        <div className="flex flex-col sm:flex-row gap-4 sm:w-auto">
                                            <Link to="/dashboard">
                                                <button className="flex items-center justify-center gap-2 px-6 py-3 bg-slate-200 dark:bg-slate-800 hover:bg-slate-300 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-bold rounded-lg transition-all transform hover:scale-[1.02] active:scale-95">
                                                    <span className="material-symbols-outlined">dashboard</span>
                                                    <span>Go to Dashboard</span>
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                
                                :

                                <Loading/>
                            }
                        </div>
                    </div>

                    <div className="flex items-center justify-between p-6 bg-surface-dark border-t-0 rounded-b-xl border border-border-dark border-t-0 mb-10 flex-col gap-4 md:flex-row">
                        <p className="text-[#92adc9] text-sm">Showing {filterPage === 1 ? "1" : (filterPage - 1) * 5} to {(filterPage) * 5} of {userSessions !== undefined ? userSessions.totals["filter_lenght"] : "0"} racing sessions</p>
                        <div className="flex items-center gap-1">
                            <button onClick={() => handlePageChange(filterPage - 1)} className="flex size-10 items-center justify-center text-[#92adc9] hover:text-white transition-colors" >
                                <span className="material-symbols-outlined">chevron_left</span>
                            </button>

                            {[...Array(totalPages)].map((_, index) => {
                                const page = index + 1;

                                if (page === 1 || page === totalPages || (page >= filterPage - 1 && page <= filterPage + 1)) {
                                    return (
                                        <button
                                            key={page}
                                            onClick={() => handlePageChange(page)}
                                            className={`text-sm size-10 flex items-center justify-center rounded-lg transition-all ${
                                                filterPage === page 
                                                ? "bg-primary text-white font-bold" 
                                                : "text-[#92adc9] font-normal hover:text-white hover:bg-border-dark"
                                            }`}
                                        >
                                            {page}
                                        </button>
                                    );
                                }

                                if (page === filterPage - 2 || page === filterPage + 2) {
                                    return <span key={page} className="text-[#92adc9] px-2">...</span>;
                                }

                                return null;
                            })}
                            
                            <button onClick={() => handlePageChange(filterPage + 1)} className="flex size-10 items-center justify-center text-[#92adc9] hover:text-white transition-colors">
                                <span className="material-symbols-outlined">chevron_right</span>
                            </button>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className="bg-surface-dark/40 p-6 rounded-xl border border-border-dark backdrop-blur-sm">
                            <p className="text-[#92adc9] text-xs font-bold uppercase tracking-widest mb-1">Total Laps Recorded</p>
                            <h3 className="text-white text-3xl font-black">{userSessions !== undefined ? userSessions.totals.laps : 0}</h3>
                        </div>
                        <div className="bg-surface-dark/40 p-6 rounded-xl border border-border-dark backdrop-blur-sm">
                            <p className="text-[#92adc9] text-xs font-bold uppercase tracking-widest mb-1">Total Distance</p>
                            <h3 className="text-white text-3xl font-black">{userSessions !== undefined ? Math.round(userSessions?.totals.distance/1000).toFixed(1) : 0} km</h3>
                        </div>
                        <div className="bg-surface-dark/40 p-6 rounded-xl border border-border-dark backdrop-blur-sm">
                            <p className="text-[#92adc9] text-xs font-bold uppercase tracking-widest mb-1">Most Driven Track</p>
                            <h3 className="text-white text-3xl font-black">{userSessions !== undefined ? userSessions["favorite_track"]?.name : "Unknown"}</h3>
                        </div>
                    </div>
                </div>
            </main>
    );
}

export default SessionsPageMain;